import template from './solidarityRequestModal.html';
import controller from './solidarityRequestModal.controller';

let solidarityRequestModalComponent = {
  restrict: 'E',
  bindings: {
    modalState: '<',
    onCancel: '&',
    onCreate: '&',
    ong: '<',
    errorMessage: '<',
    amount: '<',
  },
  template,
  controller,
};

export default solidarityRequestModalComponent;



// WEBPACK FOOTER //
// ./client/app/solidarity.module/components/solidarityRequestModal/solidarityRequestModal.component.js